import axios from 'axios';
import ImageCropPopup from '../components/ImageCropPopup/ImageCropPopup';
import React, { useEffect, useState, useRef, useCallback } from 'react';
import { Button, Col, Container, Row, Form, Modal, Table } from 'react-bootstrap';
import LeftNavbar from '../components/LeftNavbar';
import TopHeader from '../components/TopHeader';
import DragDropMultiple from '../components/DragDropMultiple';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { useParams } from 'react-router-dom';
// import { suburbData } from '../assets/data/suburbData';
import { BASE_URL } from '../components/App';
import { Link } from 'react-router-dom';
import UserSignature from './InputFields/UserSignature';
import moment from 'moment';
import DragDropSingle from '../components/DragDropSingle';
import { editUserValidation, isChangedPastDocumentExpiry, isPastCalendarDate, sanitizeFranchiseeContact } from '../helpers/validation';
import {
  FULL_NAME_MAX_LENGTH,
  PHONE_LOCAL_MAX_LENGTH,
} from '../constants/userValidation';
import { getLoggedInUserRole, isUserAllowed, formatUserFileUploadDate, toUserFileDateInputValue } from '../utils/commonMethods';
import * as ReactBootstrap from 'react-bootstrap';

import { canViewUserNote, } from '../helpers/users/profile/personalDetails/commonUserFunctions';
import { getDocumentCategoriesByRole } from '../constants/documentCategories';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

const animatedComponents = makeAnimated();

const isValidFranchiseeId = (franchiseeId) => {
  if (franchiseeId === undefined || franchiseeId === null || franchiseeId === '') return false;
  const normalized = String(franchiseeId).trim().toLowerCase();
  if (['undefined', 'null', 'none', 'nan'].includes(normalized)) return false;
  return !Number.isNaN(Number(franchiseeId));
};

const formatDateInputValue = (date) => {
  if (!date) return '';
  const parsed = moment(date);
  return parsed.isValid() ? parsed.format('YYYY-MM-DD') : '';
};

const formatDisplayDate = (date) => {
  if (!date) return '';
  const parsed = moment(date);
  return parsed.isValid() ? parsed.format('DD/MM/YYYY') : '';
};

//const training = [ { value: 'by-companies', label: 'By Companies', }, { value: 'by-round', label: 'By Round', }, ];

const EditUser = () => {
  const LSToken = localStorage.getItem('token');
  const AxiosHeaders = { headers: { Authorization: `Bearer ${LSToken}` } };
  const JsonHeaders = {
    headers: {
      Authorization: `Bearer ${LSToken}`,
      'Content-Type': 'application/json',
    },
  };

  const matchFileId = (leftId, rightId) => String(leftId) === String(rightId);

  const { userId } = useParams();
  const [LSUserRole, setLSUserRole] = useState(localStorage.getItem("user_role"));
  // REFS
  let address = useRef(null);
  let city = useRef(null);
  let crn = useRef(null);
  let email = useRef(null);
  let fullname = useRef(null);
  let phone = useRef(null);
  let postalCode = useRef(null);
  let state = useRef(null);

  const [formErrors, setFormErrors] = useState([]);
  const [formData, setFormData] = useState({
    city: 'Sydney',
    phone: '',
    role: '',
    crn: '',
    telcode: '+61',
    terminationDate: '',
    password: '',
    assign_random_password: false,
    change_pwd_next_login: false,
    document_category: 'Other',
    document_comments: '',
    document_expiry_date: '',
  });
  const [countryData, setCountryData] = useState([]);
  const [userRoleData, setUserRoleData] = useState([]);
  const [stateData, setStateData] = useState([]);
  const [cityData, setCityData] = useState();
  const [topErrorMessage, setTopErrorMessage] = useState('');
  const [selectedFranchisee, setSelectedFranchisee] = useState();
  const [franchiseeData, setFranchiseeData] = useState(null);
  //const [franchiseePlaceholder, setFranchiseePlaceholder] = useState(null);
  const [coordinatorData, setCoordinatorData] = useState([]);
  const [trainingCategoryData, setTrainingCategoryData] = useState([]);
  const [pdcData, setPdcData] = useState([]);
  const [businessAssetData, setBuinessAssetData] = useState([]);
  const [trainingDocuments, setTrainingDocuments] = useState([]);
  const [fetchedTrainingDocuments, setFetchedTrainingDocuments] = useState([]);
  const [editUserData, setEditUserData] = useState();
  const [suburbSearchString, setSuburbSearchString] = useState('');

  // IMAGE CROPPING STATES
  const [image, setImage] = useState(null);
  const [croppedImage, setCroppedImage] = useState(null);
  const [popupVisible, setPopupVisible] = useState(false);
  const [uploadError, setUploadError] = useState(null);
  const [fileError, setFileError] = useState([]);

  // DIALOG STATES
  const [showConsentDialog, setShowConsentDialog] = useState(false);
  const [showSignatureDialog, setShowSignatureDialog] = useState(false);
  const [showUserAgreementDialog, setShowUserAgreementDialog] = useState(false);
  const [signatureImage, setSignatureImage] = useState(null);
  const [isSubmit, setIsSubmit] = useState(false);
  const [signatureUploaded, setSignatureUploaded] = useState(false);
  const [loader, setLoader] = useState(false);
  const [createUserModal, setCreateUserModal] = useState(false);
  const [currentRole, setCurrentRole] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  // DOCUMENT UPLOAD METADATA (category, comments, expiry_date)
  const [documentCategory, setDocumentCategory] = useState('Other');
  const [documentComments, setDocumentComments] = useState('');
  const [documentExpiryDate, setDocumentExpiryDate] = useState('');

  // ERROR HANDLING
  const [errors, setErrors] = useState({});
  const [savingFileId, setSavingFileId] = useState(null);
  const [fileDeleteConfirm, setFileDeleteConfirm] = useState({
    show: false,
    fileId: null,
    fileName: '',
  });
  const [validationPopup, setValidationPopup] = useState({
    show: false,
    messages: [],
    type: 'error',
  });

  const openNotificationPopup = (messages = [], type = 'error') => {
    const uniqueMessages = [
      ...new Set(
        messages.filter((msg) => typeof msg === 'string' && msg.trim().length > 0)
      ),
    ];
    if (uniqueMessages.length === 0) return;
    setValidationPopup({
      show: true,
      messages: uniqueMessages.slice(0, 4),
      type,
    });
  };

  const openValidationPopup = (messages = []) => {
    openNotificationPopup(messages, 'error');
  };

  const openSuccessPopup = (messages = []) => {
    openNotificationPopup(messages, 'success');
  };

  // FETCHES THE DATA OF USER FOR EDITING
  // const fetchEditUserData = async () => {
  //   const token = localStorage.getItem('token');
  //   const response = await axios.get(`${BASE_URL}/auth/user/${userId}`, {
  //     headers: {
  //       Authorization: `Bearer ${token}`,
  //     },
  //   });

  //   if (response.status === 200 && response.data.status === 'success') {
  //     const { user } = response.data;
  //     const { userFiles } = response.data;

  //     if (Object.keys(user).length > 0) {
  //       copyDataToState(user, userFiles);
  //     } else {
  //       localStorage.setItem('success_msg', "User doesn't exist!");
  //       const userRole = LSUserRole;
  //       if (userRole === 'guardian') window.location.href = '/';
  //       else window.location.href = '/user-management';
  //     }
  //   }
  // };

  const copyDataToState = (user, files) => {
    setCurrentRole(user?.role);
    setFormData((prevState) => ({
      id: user?.id,
      fullname: user?.fullname,
      role: user?.role,
      state: user?.state,
      city: user?.city,
      address: user?.address,
      postalCode: user?.postalCode,
      crn: user?.crn,
      email: user?.email,
      telcode: user?.phone.split('-')[0],
      phone: user?.phone.split('-')[1],
      franchisee_id: user?.franchisee_id,
      nominated_assistant: user?.nominated_assistant || null,
      trainingCategories: user?.training_categories?.map((d) => parseInt(d)),
      professionalDevCategories: user?.professional_development_categories?.map(
        (d) => parseInt(d)
      ),
      coordinator: user?.coordinator ?? 0,
      businessAssets: user?.business_assets?.map((d) => parseInt(d)),
      terminationDate: user?.termination_date || '',
      termination_reach_me: user?.termination_reach_me,
      user_signature: user?.user_signature,
      profile_photo: user?.profile_photo,
      assign_random_password: user?.assign_random_password ? true : false,
      change_pwd_next_login: user?.change_pwd_next_login ? true : false,
      user_note: user?.user_note,
    }));
    setCroppedImage(user?.profile_photo);

    if (files?.length > 0) {
      const mappedFiles = files?.map((f) => {
        const expiryDateInput = toUserFileDateInputValue(f.expiry_date);
        return {
          id: f.id,
          link: f.file,
          user_id: f.user_id,
          file_name: f.name,
          category: f.category,
          comments: f.comments,
          expiry_date: f.expiry_date,
          expiry_dateInput: expiryDateInput,
          originalExpiryDateInput: expiryDateInput,
          createdAt: f.createdAt,
        };
      });
      const uniqueFiles = mappedFiles.filter(
        (file, index, arr) =>
          index ===
          arr.findIndex(
            (other) =>
              String(other.id) === String(file.id) ||
              (other.link === file.link &&
                other.file_name === file.file_name &&
                other.createdAt === file.createdAt)
          )
      );
      setFetchedTrainingDocuments(uniqueFiles);
    } else {
      setFetchedTrainingDocuments([]);
    }
  };

  const saveAllDocumentMetadata = async () => {
    if (!fetchedTrainingDocuments?.length) return;

    const invalidDoc = fetchedTrainingDocuments.find(isChangedPastDocumentExpiry);
    if (invalidDoc) {
      throw { response: { data: { msg: 'Expiry date cannot be in the past.' } } };
    }

    await Promise.all(
      fetchedTrainingDocuments.map((doc) =>
        axios.patch(
          `${BASE_URL}/auth/user/files/${doc.id}`,
          {
            comments: doc.comments || '',
            expiry_date: doc.expiry_dateInput || '',
          },
          JsonHeaders
        )
      )
    );
  };

  // CREATES NEW USER INSIDE THE DATABASE
  const updateUserDetails = async (data) => {
    try {
      const response = await axios.patch(`${BASE_URL}/auth/user/${userId}`, data, AxiosHeaders);
      if (response.status === 200 && response.data.status === 'success') {
        if (signatureImage) {
          let data = new FormData();
          const blob = await fetch(signatureImage).then((res) => res.blob());
          data.append('image', blob);
          let signatureImageResponse = await axios.put(`${BASE_URL}/auth/${response.data.userId}`, data, AxiosHeaders);

          if (signatureImageResponse.status === 201 && signatureImageResponse.data.status === 'success') {
            updateEngageBayContactList(formData);
            setCreateUserModal(false);
            setLoader(false);
            localStorage.setItem('success_msg', 'User updated successfully Termination date set!');
            const userRole = localStorage.getItem('guardian');
            if (userRole === 'guardian') window.location.href = '/';
            else window.location.href = '/user-management';

            setSignatureUploaded(true);
          } else if (signatureImageResponse.status === 201 && signatureImageResponse.data.status === 'fail') {
            setTopErrorMessage(signatureImageResponse.data.msg);
            setLoader(false);
            setCreateUserModal(false);
          }
        }

        if (signatureUploaded !== true) {
          updateEngageBayContactList(formData);
        }
      } else if (response.status === 200 && response.data.status === 'fail') {
        setTopErrorMessage(response.data.msg);
        setLoader(false);
        setCreateUserModal(false);
      }
    } catch (err) {
      setLoader(false);
      setCreateUserModal(false);
      const msg = err.response?.data?.msg || 'Something went wrong. Please try again.';
      setTopErrorMessage(msg);
      openValidationPopup([msg]);
      if (err.response?.status === 400) {
        if (msg.includes('Expiry date')) {
          setFormErrors((prev) => ({ ...prev, document_expiry_date: msg }));
        } else if (msg.includes('Category')) {
          setFormErrors((prev) => ({ ...prev, document_category: msg }));
        }
      }
    }
  };

  const updateEngageBayContactList = async (data) => {
    // PAYLOAD TO BE USED WHILE CREATING OR UPDATING
    let payload = {
      email: data.email,
      role: data.role,
      fullname: data.fullname,
      city: data.city,
      postalCode: data.postalCode,
      firstname: data.fullname.split(' ')[0],
      lastname: data.fullname.split(' ')[1],
      address: data.address,
      phone: data.phone,
    };

    // CHECKING WHETHER THE RECORD WITH GIVEN MAIL EXISTS OR NOT
    let response = await axios.get(`${BASE_URL}/contacts/data/${data.email}`, AxiosHeaders);

    if (response.status === 200 && response.data.isRecordFetched === 0) {
      // RECORD WITH THE AFOREMENTIONED EMAIL DOESN'T EXIST,
      // HENCE, CREATING A NEW RECORD INSIDE ENGAGEBAY
      // WITH THE GIVEN DETAILS
      let createResponse = await axios.post(`${BASE_URL}/contacts/create`, payload, AxiosHeaders);

      if (createResponse.status === 200 && createResponse.data.status === 'success') {
        localStorage.setItem('success_msg', 'User updated successfully');

        const userRole = LSUserRole;
        if (userRole === 'guardian') window.location.href = '/';
        else window.location.href = '/user-management';
      }
    } else if (response.status === 200 && response.data.isRecordFetched === 1) {
      // RECORD WITH THE AFOREMENTIONED EMAIL ALREADY EXISTS,
      // HENCE, UPDATING THE RECORD
      // WITH THE GIVEN DETAILS
      let updateResponse = await axios.put(`${BASE_URL}/contacts/${data.email}`, payload, AxiosHeaders);

      if (updateResponse.status === 201 && updateResponse.data.status === 'success') {
        localStorage.setItem('success_msg', 'User updated successfully');

        const userRole = LSUserRole;
        if (userRole === 'guardian') window.location.href = '/';
        else window.location.href = '/user-management'; // setLoader(false);
        // setCreateUserModal(false);
        // localStorage.setItem('success_msg', 'User created successfully!');

        // if(LSUserRole === 'coordinator' && data.role === 'guardian') {
        //   window.location.href=`/children/${data.id}`;
        // } else {
        //   window.location.href="/user-management";
        // }
      }
    }
  };

  const handleChange = (event) => {
    let { name, value } = event.target;
    // value = value.replace(/\s/g, "");
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handlePasswordChange = (event) => {
    const { value } = event.target;
    const normalizedPassword = value.trim();
    setFormData((prevData) => ({
      ...prevData,
      password: normalizedPassword,
    }));
    setFormErrors((prevState) => ({
      ...prevState,
      password: null,
    }));
  };

  const canWriteUserNote = () => {
    let role = getLoggedInUserRole();
    return (role === 'franchisor_admin' || role === 'franchisee_admin' || role === 'coordinator');
  };

  // const fetchStateList = async () => {
  //   let response = await axios.get(`${BASE_URL}/api/state/data`, {
  //     headers: {
  //       Authorization: 'Bearer ' + localStorage.getItem('token'),
  //     },
  //   });

  //   if (response.status === 200 && response.data.status === 'success') {
  //     let { states } = response.data;
  //     setStateData(
  //       states.map((d) => ({
  //         id: d.id,
  //         value: d.name,
  //         label: d.name,
  //       }))
  //     );
  //   }
  // };

  const setAutoFocus = (obj) => {
    let errArray = Object.keys(obj);

    if (errArray.includes('fullname')) {
      fullname?.current?.focus();
    } else if (errArray?.includes('state')) {
      state?.current?.focus();
    } else if (errArray?.includes('city')) {
      city?.current?.focus();
    } else if (errArray?.includes('address')) {
      address?.current?.focus();
    } else if (errArray?.includes('postalCode')) {
      postalCode?.current?.focus();
    } else if (errArray?.includes('crn')) {
      crn?.current?.focus();
    } else if (errArray?.includes('email')) {
      email?.current?.focus();
    } else if (errArray?.includes('phone')) {
      phone?.current?.focus();
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    let error = editUserValidation(
      formData,
      trainingDocuments,
      fetchedTrainingDocuments,
      documentCategory,
      documentExpiryDate
    );

    if (Object.keys(error).length > 0) {
      setFormErrors(error);
      setAutoFocus(error);
      openValidationPopup(Object.values(error));
    } else {
      let fullname = formData?.fullname.trim();
      setFormData((prevState) => ({
        ...prevState,
        fullname,
      }));
      let data = new FormData();

      let blob;
      if (croppedImage && typeof croppedImage === 'object') {
        blob = await fetch(croppedImage.getAttribute('src')).then((res) =>
          res.blob()
        );
        data.append('profile_photo', blob, 'profile.jpg');
      }

      const excludeKeys = ['document_category', 'document_comments', 'document_expiry_date', 'confirm_password'];
      Object.keys(formData)?.forEach((item) => {
        if (excludeKeys.includes(item)) return;
        const val = formData[item];
        if (val !== undefined && val !== null && val !== '') data.append(item, val);
      });
      if (!data.has('coordinator')) {
        data.append('coordinator', formData.coordinator ?? 0);
      }
      if (formData.document_category) data.append('document_category', formData.document_category);
      if (formData.document_comments) data.append('document_comments', formData.document_comments);
      if (formData.document_expiry_date) data.append('document_expiry_date', formData.document_expiry_date);

      if (trainingDocuments.length > 0) {
        data.append('category', documentCategory || 'Other');
        data.append('comments', documentComments || '');
        data.append('expiry_date', documentExpiryDate ? documentExpiryDate.replace(/-/g, '/') : '');
      }

      trainingDocuments.forEach((doc) => {
        // Preserve original filename so backend does not store generic "blob".
        data.append('images', doc, doc.name);
      });

      setCreateUserModal(true);
      setLoader(true);
      try {
        await saveAllDocumentMetadata();
        await updateUserDetails(data);
      } catch (err) {
        setLoader(false);
        setCreateUserModal(false);
        const saveMsg =
          err?.response?.data?.msg ||
          'Unable to save document comments. Please try again.';
        openValidationPopup([saveMsg]);
        if (saveMsg.includes('Expiry date')) {
          setFormErrors((prev) => ({ ...prev, document_expiry_date: saveMsg }));
        }
      }
    }
  };

  // FETCH THE OVERALL PROFILE DATA FGOR POPULATION;
  const fetchProfileData = useCallback(() => {
    let config = AxiosHeaders;
    axios
      .get(`${BASE_URL}/auth/user/profile/data/${userId}`, config)
      .then((res) => {
        let details = res.data?.details;
        let success = res.data?.success;
        if (success) {
          let {
            countryDataList,
            userRoleList,
            categoryList,
            pdcList,
            businessAssetList,
            stateData: states,
            franchiseeList,
            userData,
          } = details;

          // setting country data;
          setCountryData(
            countryDataList.map((countryData) => ({
              value: `${countryData.name}\n${countryData.dial_code}`,
              label: `${countryData.name}\n${countryData.dial_code}`,
            }))
          );

          // Setting user role list;
          let newRoleList = userRoleList.map((d) => ({
            id: d.id,
            value: d.role_name,
            label: d.role_label,
            sequence: d.role_sequence,
          }));

          setUserRoleData(newRoleList);

          // Setting franchisee list;
          setTrainingCategoryData([
            ...categoryList.map((data) => ({
              id: data.id,
              value: data.category_name,
              label: data.category_name,
            })),
          ]);

          // Setting PDC List
          setPdcData(
            pdcList.map((data) => ({
              id: data.id,
              value: data.category_name,
              label: data.category_name,
            }))
          );

          // Setting Business asset list;
          setBuinessAssetData(
            businessAssetList.map((data) => ({
              id: data.id,
              value: data.asset_name,
              label: data.asset_name,
            }))
          );

          // Setting state list;
          setStateData(
            states.map((d) => ({
              id: d.id,
              value: d.name,
              label: d.name,
            }))
          );

          // Setting franchisee List;
          setFranchiseeData(
            franchiseeList.map((franchisee) => ({
              id: franchisee.id,
              value: franchisee.franchisee_name,
              label: franchisee.franchisee_name,
            }))
          );

          // Setting user details for editing;
          const { user, userFiles } = userData;

          if (Object.keys(user).length > 0) {
            copyDataToState(user, userFiles);
          } else {
            localStorage.setItem('success_msg', "User doesn't exist!");
            const userRole = LSUserRole;
            if (userRole === 'guardian') window.location.href = '/';
            else window.location.href = '/user-management';
          }
        }
      })
      .catch(() => {});
  }, []);

  // FETCHES COUNTRY CODES FROM THE DATABASE AND POPULATES THE DROP DOWN LIST
  // const fetchCountryData = async () => {
  //   const token = localStorage.getItem('token');
  //   const response = await axios.get(`${BASE_URL}/api/country-data`, {
  //     headers: {
  //       Authorization: 'Bearer ' + token,
  //     },
  //   });
  //   if (response.status === 200) {
  //     const { countryDataList } = response.data;
  //     setCountryData(
  //       countryDataList.map((countryData) => ({
  //         value: `${countryData.name}\n${countryData.dial_code}`,
  //         label: `${countryData.name}\n${countryData.dial_code}`,
  //       }))
  //     );
  //   }
  // };

  // FETCHES USER ROLES FROM THE DATABASE AND POPULATES THE DROP DOWN LIST
  // const fetchUserRoleData = async () => {
  //   const token = localStorage.getItem('token');
  //   const response = await axios.get(`${BASE_URL}/api/user-role`, {
  //     headers: {
  //       Authorization: 'Bearer ' + token,
  //     },
  //   });
  //   if (response.status === 200) {
  //     const { userRoleList } = response.data;

  //     let newRoleList = userRoleList.map((d) => ({
  //       id: d.id,
  //       value: d.role_name,
  //       label: d.role_label,
  //       sequence: d.role_sequence,
  //     }));

  //     setUserRoleData(newRoleList);
  //   }
  // };

  // FETCHING SUBURB DATA
  const fetchSuburbData = (state) => {
    if (!state) {
      setCityData([]);
      return;
    }
    const suburbAPI = `${BASE_URL}/api/suburbs/data/${state}`;
    const getSuburbList = axios(suburbAPI, AxiosHeaders);
    axios.all([getSuburbList]).then(
      axios.spread((...data) => {
        let sdata = data[0].data.data;
        setCityData(
          sdata.map((d) => ({
            id: d.id,
            value: d.name,
            label: d.name,
          }))
        );
      })
    ).catch(() => {
      setCityData([]);
    });
  };

  // const fetchTrainingCategories = async () => {
  //   let token = localStorage.getItem('token');
  //   const response = await axios.get(
  //     `${BASE_URL}/training/get-training-categories`,
  //     {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //     }
  //   );
  //   if (response.status === 200 && response.data.status === 'success') {
  //     const { categoryList } = response.data;
  //     setTrainingCategoryData([
  //       ...categoryList.map((data) => ({
  //         id: data.id,
  //         value: data.category_name,
  //         label: data.category_name,
  //       })),
  //     ]);
  //   }
  // };

  // const fetchProfessionalDevelopementCategories = async () => {
  //   let token = localStorage.getItem('token');
  //   const response = await axios.get(`${BASE_URL}/api/get-pdc`, {
  //     headers: {
  //       Authorization: `Bearer ${token}`,
  //     },
  //   });

  //   if (response.status === 200 && response.data.status === 'success') {
  //     const { pdcList } = response.data;
  //     setPdcData(
  //       pdcList.map((data) => ({
  //         id: data.id,
  //         value: data.category_name,
  //         label: data.category_name,
  //       }))
  //     );
  //   }
  // };

  // const fetchBuinessAssets = async () => {
  //   let token = localStorage.getItem('token');
  //   const response = await axios.get(`${BASE_URL}/api/get-business-assets`, {
  //     headers: {
  //       Authorization: `Bearer ${token}`,
  //     },
  //   });

  //   if (response.status === 200 && response.data.status === 'success') {
  //     const { businessAssetList } = response.data;
  //     setBuinessAssetData(
  //       businessAssetList.map((data) => ({
  //         id: data.id,
  //         value: data.asset_name,
  //         label: data.asset_name,
  //       }))
  //     );
  //   }
  // };

  // const fetchFranchiseeList = async () => {
  //   const token = localStorage.getItem('token');
  //   const response = await axios.get(`${BASE_URL}/role/franchisee`, {
  //     headers: {
  //       Authorization: `Bearer ${token}`,
  //     },
  //   });
  //   if (response.status === 200 && response.data.status === 'success') {
  //     let { franchiseeList } = response.data;

  //     setFranchiseeData(
  //       franchiseeList.map((franchisee) => ({
  //         id: franchisee.id,
  //         value: franchisee.franchisee_name,
  //         label: franchisee.franchisee_name,
  //       }))
  //     );
  //   }
  // };

  const fetchCoordinatorData = async (franchisee_id) => {
    if (!isValidFranchiseeId(franchisee_id)) {
      setCoordinatorData([]);
      return;
    }
    try {
      const response = await axios.get(`${BASE_URL}/role/franchisee/coordinator/franchiseeID/${franchisee_id}/coordinator`, AxiosHeaders);
      if (response.status === 200 && response.data.status === 'success') {
        let { coordinators } = response.data;
        setCoordinatorData(
          coordinators.map((coordinator) => ({
            id: coordinator.id,
            value: coordinator.fullname,
            label: coordinator.fullname,
          }))
        );
      }
    } catch (e) {
      setCoordinatorData([]);
    }
  };

  // DIALOG HANDLING
  const handleConsentDialog = () => {
    if (
      formData?.termination_reach_me &&
      formData?.terminationDate.length > 0
    ) {
      setShowConsentDialog(false);
      setShowSignatureDialog(true);
    }
  };

  const handleSignatureDialog = (data) => {
    setSignatureImage(data);
    if (signatureImage) {
      setShowSignatureDialog(false);
    }
  };

  const trimRoleList = () => {
    let newRoleList = userRoleData;

    if (currentRole === 'educator') {
      if (LSUserRole === 'coordinator') {
        newRoleList = newRoleList.filter(
          (role) => role.sequence > 2 && role.sequence < 5
        );
      } else if (LSUserRole === 'franchisee_admin') {
        newRoleList = newRoleList.filter(
          (role) => role.sequence > 2 && role.sequence < 5
        );
      } else {
        newRoleList = newRoleList.filter((role) => role.sequence < 5);
      }
      setUserRoleData(newRoleList);
    }

    if (currentRole === 'coordinator') {
      if (LSUserRole === 'franchisee_admin') {
        newRoleList = newRoleList.filter(
          (role) => role.sequence > 2 && role.sequence < 4
        );
      } else {
        newRoleList = newRoleList.filter((role) => role.sequence < 4);
      }
      setUserRoleData(newRoleList);
    }

    if (currentRole === 'franchisee_admin') {
      newRoleList = newRoleList.filter(
        (role) => role.sequence < 3 && role.sequence > 1
      );
      setUserRoleData(newRoleList);
    }

    if (currentRole === 'guardian') {
      newRoleList = newRoleList.filter((role) => role.sequence === 5);
      setUserRoleData(newRoleList);
    }
  };

  const openFileDeleteConfirm = (fileId, fileName) => {
    setFileDeleteConfirm({
      show: true,
      fileId,
      fileName: fileName || 'this document',
    });
  };

  const closeFileDeleteConfirm = () => {
    setFileDeleteConfirm({
      show: false,
      fileId: null,
      fileName: '',
    });
  };

  const handleUserFileDelete = async (fileId) => {
    try {
      let response = await axios.delete(`${BASE_URL}/auth/user/files/${fileId}`, AxiosHeaders);
      if (response.status === 201 && response.data.status === 'success') {
        openSuccessPopup(['File deleted successfully']);
        closeFileDeleteConfirm();

        setFetchedTrainingDocuments((prev) =>
          prev.filter((d) => !matchFileId(d.id, fileId))
        );
      }
    } catch (err) {
      openValidationPopup([
        err?.response?.data?.msg || 'Unable to delete the file. Please try again.',
      ]);
    }
  };

  const confirmUserFileDelete = () => {
    if (fileDeleteConfirm.fileId) {
      handleUserFileDelete(fileDeleteConfirm.fileId);
    }
  };

  const handleUserFileMetadataChange = (fileId, field, value) => {
    setFetchedTrainingDocuments((prev) => {
      if (field === 'expiry_dateInput' && value && isPastCalendarDate(value)) {
        const doc = prev.find((item) => matchFileId(item.id, fileId));
        const originalInput =
          doc?.originalExpiryDateInput != null
            ? doc.originalExpiryDateInput
            : toUserFileDateInputValue(doc?.expiry_date);
        if (value !== originalInput) {
          openValidationPopup(['Expiry date cannot be in the past']);
          return prev;
        }
      }

      return prev.map((doc) =>
        matchFileId(doc.id, fileId) ? { ...doc, [field]: value } : doc
      );
    });
  };

  const handleUserFileMetadataSave = async (doc) => {
    if (isChangedPastDocumentExpiry(doc)) {
      openValidationPopup(['Expiry date cannot be in the past']);
      return;
    }

    try {
      setSavingFileId(doc.id);
      const response = await axios.patch(
        `${BASE_URL}/auth/user/files/${doc.id}`,
        {
          comments: doc.comments || '',
          expiry_date: doc.expiry_dateInput || '',
        },
        JsonHeaders
      );

      if (response.status === 200 && response.data.status === 'success') {
        const updated = response.data.data;
        const updatedExpiryInput = toUserFileDateInputValue(updated.expiry_date);
        setFetchedTrainingDocuments((prev) =>
          prev.map((item) =>
            matchFileId(item.id, doc.id)
              ? {
                  ...item,
                  comments: updated.comments,
                  expiry_date: updated.expiry_date,
                  expiry_dateInput: updatedExpiryInput,
                  originalExpiryDateInput: updatedExpiryInput,
                }
              : item
          )
        );
        openSuccessPopup(['Document details updated successfully']);
      }
    } catch (err) {
      openValidationPopup([
        err?.response?.data?.msg || 'Unable to update document details. Please try again.',
      ]);
    } finally {
      setSavingFileId(null);
    }
  };

  useEffect(() => {
    // fetchCountryData();
    // fetchUserRoleData();
    // fetchTrainingCategories();
    // fetchProfessionalDevelopementCategories();
    // fetchBuinessAssets();
    // fetchEditUserData();
    // fetchFranchiseeList();
    // fetchStateList();
    fetchProfileData();
  }, [fetchProfileData]);

  useEffect(() => {
    fetchSuburbData(formData.state);
  }, [formData.state]);

  // useEffect(() => {
  //   copyDataToState();
  // }, [editUserData]);

  useEffect(() => {
    if (formData?.role === 'educator') {
      fetchCoordinatorData(formData.franchisee_id);
    } else {
      setCoordinatorData([]);
    }
  }, [formData.franchisee_id, formData.role]);

  useEffect(() => {
    trimRoleList();
  }, [currentRole]);

  useEffect(() => {
    if (trainingDocuments?.length + fetchedTrainingDocuments.length < 5) {
      setFormErrors((prevState) => ({
        ...prevState,
        doc: null,
      }));
    }
  }, [trainingDocuments, fetchedTrainingDocuments]);

  const getUniqueErrors = (arr) => {
    var result = [];
    arr.forEach(function (item) {
      if (result.indexOf(item) < 0) {
        result.push(item);
      }
    });

    return result;
  };

  useEffect(() => {
    setFileError(uploadError?.map((errObj) => errObj?.error[0]?.message));
  }, [uploadError]);

  useEffect(() => {
    if (!validationPopup.show) return;
    const timer = setTimeout(() => {
      setValidationPopup((prev) => ({ ...prev, show: false }));
    }, 3500);
    return () => clearTimeout(timer);
  }, [validationPopup.show]);

  return (
    <>
      {validationPopup.show && (
        <div
          className={`alert alert-${validationPopup.type === 'success' ? 'success' : 'danger'}`}
          style={{
            position: 'fixed',
            top: '16px',
            right: '16px',
            zIndex: 1100,
            maxWidth: '360px',
            boxShadow: '0 8px 22px rgba(0,0,0,0.12)',
            borderRadius: '8px',
            paddingBottom: '10px',
          }}
        >
          <strong>
            {validationPopup.type === 'success' ? 'Success' : 'Please fix these fields:'}
          </strong>
          <ul style={{ marginTop: '8px', marginBottom: 0, paddingLeft: '18px' }}>
            {validationPopup.messages.map((msg) => (
              <li key={msg} style={{ marginBottom: '2px' }}>{msg}</li>
            ))}
          </ul>
        </div>
      )}
      <div id="main">
        <section className="mainsection">
          <Container>
            <div className="admin-wrapper">
              <aside className="app-sidebar"> <LeftNavbar /> </aside>
              <div className="sec-column">
                <TopHeader setSelectedFranchisee={setSelectedFranchisee} />
                <div className="entry-container">
                  <header className="title-head">
                    <h1 className="title-lg">Edit User</h1>
                  </header>
                  <div className="maincolumn">
                    <div className="new-user-sec">
                      <div className="user-pic-sec">
                        <DragDropSingle
                          croppedImage={croppedImage}
                          setCroppedImage={setCroppedImage}
                          onSave={setImage}
                          setPopupVisible={setPopupVisible}
                          fetchedPhoto={formData?.profile_photo || ''}
                        />
                        <span className="error"> {!formData.file && formErrors.file} </span>

                        {popupVisible && (<ImageCropPopup image={image} setCroppedImage={setCroppedImage} setPopupVisible={setPopupVisible} />)}
                      </div>
                      <form className="user-form error-sec" onSubmit={handleSubmit} autoComplete="off">
                        <Row>
                          <Form.Group className="col-md-6 mb-3 relative">
                            <Form.Label>Full Name *</Form.Label>
                            <Form.Control type="text" name="fullname" ref={fullname} maxLength={FULL_NAME_MAX_LENGTH} value={formData?.fullname}
                              onChange={(e) => {
                                handleChange(e);
                                setFormErrors((prevState) => ({
                                  ...prevState,
                                  fullname: null,
                                }));
                              }}
                            />
                            {formErrors.fullname !== null && (<span className="error"> {formErrors.fullname} </span>)}
                          </Form.Group>

                          <Form.Group className="col-md-6 mb-3 relative">
                            <Form.Label>User Role *</Form.Label>
                            <Select
                              placeholder="Select"
                              closeMenuOnSelect={true}
                              isDisabled={LSUserRole === 'educator' || LSUserRole === 'guardian'}
                              value={
                                userRoleData.filter(
                                  (d) => d.value === formData?.role
                                ) || ''
                              }
                              options={userRoleData}
                              onChange={(e) =>
                                setFormData((prevState) => ({
                                  ...prevState,
                                  role: e.value,
                                  roleObj: e,
                                }))
                              }
                            />
                            {/* <span className="error">
                              {!formData.role && formErrors.role}
                            </span> */}
                          </Form.Group>

                          <Form.Group className="col-md-6 mb-3">
                            <Form.Label>State *</Form.Label>
                            <Select placeholder="Select" ref={state} closeMenuOnSelect={true} options={stateData}
                              value={stateData?.filter(
                                (d) => d.label === formData?.state
                              )}
                              onChange={(e) => {
                                setFormData((prevState) => ({
                                  ...prevState,
                                  state: e.value,
                                  city: '',
                                }));

                                setFormErrors((prevState) => ({ ...prevState, city: null, }));
                              }}
                            />
                            {formErrors.state !== null && (
                              <span className="error">{formErrors.state}</span>
                            )}
                          </Form.Group>

                          <Form.Group className="col-md-6 mb-3 relative">
                            <Form.Label>Suburb *</Form.Label>
                            <Select placeholder="Select" closeMenuOnSelect={true} ref={city} options={cityData}
                              value={cityData?.filter((d) => d.label === formData?.city)}
                              onInputChange={(e) => {
                                setSuburbSearchString(e);
                              }}
                              onChange={(e) => {
                                setFormData((prevState) => ({
                                  ...prevState,
                                  city: e.value,
                                }));

                                setFormErrors((prevState) => ({
                                  ...prevState,
                                  city: null,
                                }));
                              }}
                            />
                            {formErrors.city !== null && (<span className="error">{formErrors.city}</span>)}
                          </Form.Group>

                          <Form.Group className="col-md-6 mb-3 relative">
                            <Form.Label>Address *</Form.Label>
                            <Form.Control type="text" name="address" ref={address} value={formData.address}
                              onChange={(e) => {
                                handleChange(e);
                                setFormErrors((prevState) => ({
                                  ...prevState,
                                  address: null,
                                }));
                              }}
                            />
                            {formErrors.address !== null && (<span className="error"> {formErrors.address} </span>)}
                          </Form.Group>

                          <Form.Group className="col-md-6 mb-3 relative">
                            <Form.Label>Post Code *</Form.Label>
                            <Form.Control type="text" name="postalCode" ref={postalCode} maxLength={4} value={formData.postalCode} onChange={handleChange} />
                            {formErrors.postalCode !== null && (<span className="error"> {formErrors.postalCode} </span>)}
                          </Form.Group>

                          {formData?.role === 'guardian' && (
                            <Form.Group className="col-md-6 mb-3 relative">
                              <Form.Label>CRN *</Form.Label>
                              <Form.Control type="text" disabled={LSUserRole === 'guardian'} ref={crn} name="crn" value={formData.crn}
                                onChange={(e) => {
                                  handleChange(e);
                                  setFormErrors((prevState) => ({
                                    ...prevState,
                                    crn: null,
                                  }));
                                }}
                              />
                              {formErrors.crn !== null && (<span className="error">{formErrors.crn}</span>)}
                            </Form.Group>
                          )}

                          <Form.Group className="col-md-6 mb-3 relative">
                            <Form.Label>Email Address *</Form.Label>
                            <Form.Control type="email" name="email" ref={email} value={formData.email} onChange={handleChange} />
                            {formErrors.email !== null && (<span className="error">{formErrors.email}</span>)}
                          </Form.Group>

                          {formData && formData?.role !== 'guardian' && (
                            <Form.Group className="col-md-6 mb-3 relative">
                              <Form.Label>Training Categories</Form.Label>
                              <Select
                                closeMenuOnSelect={false}
                                components={animatedComponents}
                                isMulti
                                isClearable={false}
                                placeholder="Select"
                                value={trainingCategoryData?.filter((d) =>
                                  formData?.trainingCategories?.includes(
                                    parseInt(d.id)
                                  )
                                )}
                                options={trainingCategoryData}
                                onChange={(selectedOptions) => {
                                  setFormData((prevState) => ({
                                    ...prevState,
                                    trainingCategories: [
                                      ...selectedOptions.map(
                                        (option) => option.id
                                      ),
                                    ],
                                  }));
                                }}
                              />
                            </Form.Group>
                          )}

                          {formData && formData?.role !== 'guardian' && (
                            <Form.Group className="col-md-6 mb-3 relative">
                              <Form.Label> Professional Development Categories </Form.Label>
                              <Select closeMenuOnSelect={false} components={animatedComponents} isMulti isClearable={false} placeholder="Select"
                                value={pdcData?.filter((d) =>
                                  formData?.professionalDevCategories?.includes(
                                    parseInt(d.id)
                                  )
                                )}
                                options={pdcData}
                                onChange={(selectedOptions) => {
                                  setFormData((prevState) => ({
                                    ...prevState,
                                    professionalDevCategories: [
                                      ...selectedOptions.map(
                                        (option) => option.id
                                      ),
                                    ],
                                  }));
                                }}
                              />
                            </Form.Group>
                          )}

                          <Form.Group className="col-md-6 mb-3 relative">
                            <Form.Label>Contact Number *</Form.Label>
                            <div className="tel-col">
                              <Select closeMenuOnSelect={true} placeholder="+61" className="telcode" options={countryData}
                                onChange={(e) => setFormData((prevState) => ({ ...prevState, telcode: e.value.split('\n')[1], }))}
                              />
                              <Form.Control type="tel" name="phone" ref={phone} maxLength={PHONE_LOCAL_MAX_LENGTH} value={formData.phone}
                                onChange={(e) => {
                                  setFormData((prevState) => ({
                                    ...prevState,
                                    phone: sanitizeFranchiseeContact(e.target.value),
                                  }));
                                  setFormErrors((prevState) => ({
                                    ...prevState,
                                    phone: null,
                                  }));
                                }}
                              />
                            </div>
                            {formErrors.phone !== null && (<span className="error">{formErrors.phone}</span>)}
                          </Form.Group>

                          {formData && formData?.role === 'educator' && (
                            <Form.Group className="col-md-6 mb-3 relative">
                              <Form.Label>Nominated Assistant *</Form.Label>
                              <Form.Control type="text" name="nominated_assistant" value={formData?.nominated_assistant || ''} onChange={(e) => { handleChange(e); }} />
                            </Form.Group>
                          )}

                          <Form.Group className="col-md-6 mb-3 relative">
                            <Form.Label>Select Franchise *</Form.Label>
                            <Select placeholder={'Select'} closeMenuOnSelect={true} options={franchiseeData} isDisabled={LSUserRole !== 'franchisor_admin'}
                              // isMulti
                              value={franchiseeData?.filter(
                                (data) =>
                                  parseInt(data.id) ===
                                  parseInt(formData?.franchisee_id)
                              )}
                              onChange={(e) => {
                                setFormData((prevState) => ({ ...prevState, franchisee_id: e.id, open_coordinator: false, }));
                                setFormData((prevState) => ({ ...prevState, franchiseeObj: e, }));
                                setFormErrors((prevState) => ({ ...prevState, franchisee: null, }));
                              }}
                            />
                          </Form.Group>

                          {formData?.role === 'educator' && (
                            <Form.Group className="col-md-6 mb-3 relative">
                              <Form.Label> Select Primary Coordinator * </Form.Label>
                              <Select isDisabled={formData.role !== 'educator'} placeholder={formData.role === 'educator' ? 'Select' : 'disabled'}
                                closeMenuOnSelect={true}
                                value={coordinatorData?.filter((data) => parseInt(data.id) === parseInt(formData?.coordinator))}
                                options={coordinatorData}
                                onChange={(e) => {
                                  setFormData((prevState) => ({ ...prevState, coordinator: e.id, }));
                                  setFormData((prevState) => ({ ...prevState, coordinatorObj: e, }));
                                }}
                              />
                            </Form.Group>
                          )}

                          {formData && formData?.role !== 'guardian' && (
                            <Form.Group className="col-md-12 mb-3 relative">
                              <Form.Label>Business Assets</Form.Label>
                              <Select closeMenuOnSelect={false} components={animatedComponents} isMulti placeholder="Select" isClearable={false}
                                value={businessAssetData?.filter((d) => formData?.businessAssets?.includes(parseInt(d.id)))}
                                options={businessAssetData}
                                onChange={(selectedOptions) => {
                                  setFormData((prevState) => ({ ...prevState, businessAssets: [...selectedOptions.map((option) => option.id),], }));
                                }}
                              />
                            </Form.Group>
                          )}

                          {formData?.assign_random_password === false && (
                            <>
                              <Form.Group className="col-md-6 mb-3">
                                <Form.Label>Password</Form.Label>
                                <div className="relative">
                                  <Form.Control
                                    type={showPassword ? 'text' : 'password'}
                                    name="edit_user_password"
                                    autoComplete="new-password"
                                    disabled={formData?.assign_random_password === true}
                                    value={formData.password ?? ''}
                                    onChange={handlePasswordChange}
                                    style={{ paddingRight: '2.25rem' }}
                                  />
                                  <FontAwesomeIcon
                                    onClick={() => setShowPassword((prev) => !prev)}
                                    className="custom_hide"
                                    style={{ top: '50%', transform: 'translateY(-50%)' }}
                                    icon={showPassword ? faEye : faEyeSlash}
                                  />
                                </div>
                                <span style={{ marginTop: '5px', marginBottom: 0 }} className="fileinput" >
                                  (Minimum 8 characters, at least one uppercase,
                                  one lowercase, one number and one special
                                  character)
                                </span>
                                {formErrors.password !== null && (<span className="error" style={{ marginBottom: '10px' }} > {formErrors.password} </span>)}
                              </Form.Group>

                              <Form.Group className="col-md-6 mb-3">
                                <Form.Label>Confirm Password</Form.Label>
                                <div className="relative">
                                  <Form.Control
                                    type={showConfirmPassword ? 'text' : 'password'}
                                    name="edit_user_confirm_password"
                                    autoComplete="new-password"
                                    disabled={formData?.assign_random_password === true}
                                    value={formData.confirm_password ?? ''}
                                    onChange={(e) => {
                                      setFormData((prevData) => ({
                                        ...prevData,
                                        confirm_password: e.target.value.trim(),
                                      }));
                                      setFormErrors((prevState) => ({
                                        ...prevState,
                                        confirm_password: null,
                                      }));
                                    }}
                                    style={{ paddingRight: '2.25rem' }}
                                  />
                                  <FontAwesomeIcon
                                    onClick={() => setShowConfirmPassword((prev) => !prev)}
                                    className="custom_hide"
                                    style={{ top: '50%', transform: 'translateY(-50%)' }}
                                    icon={showConfirmPassword ? faEye : faEyeSlash}
                                  />
                                </div>
                                {formErrors.confirm_password !== null && (<span className="error"> {formErrors.confirm_password} </span>)}
                              </Form.Group>
                            </>
                          )}
                          {canWriteUserNote() && isUserAllowed(formData?.role, ['educator', 'guardian',]) && (
                            <div className="col-md-12 mb-3">
                              <Form.Group className="mb-3 relative">
                                <Form.Label>User Note</Form.Label>
                                <Form.Control style={{ resize: 'none' }} type="text" as="textarea" rows={5} name="user_note" value={formData?.user_note || ''} onChange={(e) => { handleChange(e); }} />
                              </Form.Group>
                            </div>
                          )}
                          <div className="col-md-12 mb-3 relative passopt mt-3">
                            <Form.Label>Password Settings</Form.Label>
                            <Form.Group>
                              <div className="btn-checkbox">
                                <Form.Check type="checkbox" id="assign" className="p-0" checked={formData?.assign_random_password} label="Assign random password (sent to user via email)"
                                  onChange={(e) => {
                                    if (formData?.assign_random_password === false) {
                                      setFormData((prevState) => ({ ...prevState, password: null, confirm_password: null, }));
                                    }
                                    setFormData((prevState) => ({ ...prevState, assign_random_password: !formData?.assign_random_password, }));
                                  }}
                                />
                              </div>

                              <div className="btn-checkbox">
                                <Form.Check type="checkbox" id="change" className="p-0" checked={formData?.change_pwd_next_login} label="Change password during next login"
                                  onChange={(e) => {
                                    setFormData((prevState) => ({ ...prevState, change_pwd_next_login: !formData?.change_pwd_next_login, }));
                                  }}
                                />
                              </div>
                            </Form.Group>
                          </div>

                          <Form.Group className="col-md-6 mb-3 relative">
                            <Form.Label>Termination Date</Form.Label>
                            <Form.Control type="date" disabled={true} name="terminationDate" value={formatDateInputValue(formData?.terminationDate)}
                              onChange={(e) => setFormData((prevState) => ({ ...prevState, terminationData: e.target.value, }))} />
                            {(formData.termination_reach_me === false || formData.termination_reach_me === null) && parseInt(localStorage.getItem('user_id')) === parseInt(formData.id) && (
                              <p style={{ fontSize: '13px', marginTop: '10px', }} > Please fill in{' '} <strong style={{ color: '#C2488D', cursor: 'pointer', }} > <span onClick={() => setShowConsentDialog(true)} > Termination Consent Form </span> </strong>{' '} to set termination date </p>
                            )}
                            {formData.termination_reach_me === true &&
                              parseInt(localStorage.getItem('user_id')) ===
                              parseInt(formData.id) && (
                                <div>
                                  <p style={{ fontSize: '14px' }}> You've consented to be terminated on{' '} <strong style={{ color: '#C2488D' }}> {formatDisplayDate(formData?.terminationDate)}{' '} <span style={{ cursor: 'pointer' }} onClick={() => setShowConsentDialog(true)} > (edit) </span> </strong> . </p>
                                  <img style={{ width: '40px', height: 'auto' }} src={`${signatureImage || formData.user_signature}`} alt="" />
                                </div>
                              )}
                            {(LSUserRole === 'franchisor_admin' || LSUserRole === 'franchisee_admin') && formData?.termination_reach_me === true && (
                              <div>
                                <p style={{ fontSize: '14px', marginTop: '10px', }} > Consent Form:{' '} <strong style={{ color: '#C2488D', cursor: 'pointer', }} onClick={() => setShowUserAgreementDialog(true)} > Click Here! </strong> </p>
                              </div>
                            )}
                          </Form.Group>

                          {canViewUserNote() && (
                            <Form.Group className="col-md-12 mb-3 relative">
                              <Form.Label>Upload Documents</Form.Label>
                              <div className="mb-2">
                                <Form.Label className="small mb-1">Category *</Form.Label>
                                <Form.Select
                                  value={documentCategory}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    setDocumentCategory(value);
                                    setFormData((prev) => ({ ...prev, document_category: value }));
                                    setFormErrors((prev) => ({ ...prev, document_category: null }));
                                  }}
                                  aria-label="Document category"
                                >
                                  {getDocumentCategoriesByRole(formData?.role || currentRole).map((cat) => (
                                    <option key={cat} value={cat}>{cat}</option>
                                  ))}
                                </Form.Select>
                              </div>
                              <div className="mb-2">
                                <Form.Label className="small mb-1">Comments (optional)</Form.Label>
                                <Form.Control
                                  as="textarea"
                                  rows={2}
                                  value={documentComments}
                                  onChange={(e) => setDocumentComments(e.target.value)}
                                  placeholder="Add comments for this upload"
                                />
                              </div>
                              <div className="mb-2">
                                <Form.Label className="small mb-1">Expiry date (optional)</Form.Label>
                                <Form.Control
                                  type="date"
                                  value={documentExpiryDate}
                                  min={new Date().toISOString().slice(0, 10)}
                                  onChange={(e) => {
                                    setDocumentExpiryDate(e.target.value);
                                    setFormErrors((prev) => ({ ...prev, document_expiry_date: null }));
                                  }}
                                  isInvalid={formErrors.document_expiry_date != null}
                                />
                                {formErrors.document_expiry_date != null && (
                                  <span className="error">{formErrors.document_expiry_date}</span>
                                )}
                              </div>
                              <DragDropMultiple module="user-management" onSave={setTrainingDocuments} setUploadError={setUploadError} />
                              {fileError && getUniqueErrors(fileError).map((errorObj) => {
                                return (
                                  <p key={errorObj} style={{ color: 'tomato', fontSize: '12px', }} > {errorObj === 'Too many files' ? 'Only 20 files allowed' : errorObj.includes('File type must be text/*') ? "zip file uploads aren't allowed" : errorObj} </p>
                                );
                              })}
                              {fetchedTrainingDocuments && fetchedTrainingDocuments.length > 0 && (
                                <div className="mt-3">
                                  <Form.Label className="small">Uploaded documents</Form.Label>
                                  <div
                                    className="border rounded p-2 bg-light"
                                    style={{ maxHeight: '260px', overflowY: 'auto' }}
                                  >
                                    <Table striped bordered hover size="sm" responsive className="mb-0">
                                      <thead>
                                        <tr>
                                          <th>File name</th>
                                          <th>Category</th>
                                          <th>Expiry date</th>
                                          <th>Comments</th>
                                          <th>Uploaded</th>
                                          <th>Actions</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {fetchedTrainingDocuments.map((doc) => {
                                          const displayName =
                                            doc.file_name ||
                                            doc.name ||
                                            (doc.link &&
                                              doc.link.split('/').slice(-1)[0].split('?')[0]) ||
                                            'Document';

                                          return (
                                            <tr key={doc.id}>
                                              <td>
                                                <a href={doc?.link} target="_blank" rel="noopener noreferrer">
                                                  {displayName}
                                                </a>
                                              </td>
                                              <td>{doc.category || '-'}</td>
                                              <td>
                                                <Form.Control
                                                  type="date"
                                                  size="sm"
                                                  value={doc.expiry_dateInput || ''}
                                                  min={
                                                    doc.originalExpiryDateInput &&
                                                    isPastCalendarDate(doc.originalExpiryDateInput)
                                                      ? undefined
                                                      : new Date().toISOString().slice(0, 10)
                                                  }
                                                  onChange={(e) =>
                                                    handleUserFileMetadataChange(
                                                      doc.id,
                                                      'expiry_dateInput',
                                                      e.target.value
                                                    )
                                                  }
                                                />
                                              </td>
                                              <td>
                                                <Form.Control
                                                  as="textarea"
                                                  rows={1}
                                                  size="sm"
                                                  value={doc.comments || ''}
                                                  placeholder="Add comments"
                                                  onChange={(e) =>
                                                    handleUserFileMetadataChange(
                                                      doc.id,
                                                      'comments',
                                                      e.target.value
                                                    )
                                                  }
                                                />
                                              </td>
                                              <td>{formatUserFileUploadDate(doc.createdAt)}</td>
                                              <td className="text-center text-nowrap">
                                                <Button
                                                  type="button"
                                                  variant="link"
                                                  size="sm"
                                                  className="p-0 me-2"
                                                  disabled={savingFileId === doc.id}
                                                  onClick={() => handleUserFileMetadataSave(doc)}
                                                >
                                                  {savingFileId === doc.id ? 'Saving...' : 'Save'}
                                                </Button>
                                                <button
                                                  type="button"
                                                  className="btn btn-link p-0 border-0"
                                                  onClick={() => openFileDeleteConfirm(doc?.id, displayName)}
                                                  aria-label={`Delete ${displayName}`}
                                                >
                                                  <img
                                                    src="../img/removeIcon.svg"
                                                    alt="Delete"
                                                    style={{ width: '16px', height: '16px', cursor: 'pointer' }}
                                                  />
                                                </button>
                                              </td>
                                            </tr>
                                          );
                                        })}
                                      </tbody>
                                    </Table>
                                  </div>
                                </div>
                              )}
                              {formErrors.doc !== null && (<span className="error">{formErrors.doc}</span>)}
                              {formErrors.document_category != null && (
                                <span className="error">{formErrors.document_category}</span>
                              )}
                            </Form.Group>
                          )}
                          <Col md={12}>
                            <div className="cta text-center mt-5">
                              <Button variant="transparent" className="me-3"> <Link to="/user-management">Cancel</Link> </Button>
                              <Button variant="primary" type="submit"> Save Details </Button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Container>
          {
            <Modal size="lg" show={showUserAgreementDialog} onHide={() => setShowUserAgreementDialog(false)} >
              <Modal.Header> <Modal.Title>Termination Agreement</Modal.Title> </Modal.Header>
              <Modal.Body>
                <Row>
                  <p> <strong>To whom it may concern,</strong> </p>
                  <div className="mt-2">
                    <p style={{ fontSize: '16px' }}> I hereby formally provide notice of my intention to terminate my arrangement with Mona. </p>
                    <p style={{ marginTop: '-10px', fontSize: '16px' }}> I am mindful of the required notice period, and propose a termination date of{' '} <strong style={{ color: '#C2488D' }}> {formatDisplayDate(formData.terminationDate)} </strong> . </p>
                  </div>
                  <p></p>
                  <p className="form-check-label" htmlFor="flexCheckDefault"> I am happy to be reached if you have any questions. </p>
                  <img style={{ width: '200px', height: 'auto' }} src={signatureImage || formData?.user_signature} alt="consented user signature" />
                </Row>
              </Modal.Body>

              <Modal.Footer style={{ alignItems: 'center', justifyContent: 'center', padding: '45px 60px', }} >
                <div className="text-center">
                  <button type="button" className="btn btn-primary" style={{ borderRadius: '5px', backgroundColor: '#3E5D58', padding: '8px 18px', }} onClick={() => setShowUserAgreementDialog(false)} > Close </button>
                </div>
              </Modal.Footer>
            </Modal>
          }
          {<Modal size="lg" show={showConsentDialog} onHide={() => setShowConsentDialog(false)} >
            <Modal.Header> <Modal.Title>Termination</Modal.Title> </Modal.Header>

            <Modal.Body>
              <Row>
                <p> <strong>To whom it may concern,</strong> </p>
                <div className="mt-2">
                  <p style={{ fontSize: '16px' }}> I hereby formally provide notice of my intention to terminate my arrangement with Mona. </p>
                  <p style={{ marginTop: '-10px', fontSize: '16px' }}> I am mindful of the required notice period, and propose a termination date of: </p>
                </div>
                <div className="row">
                  <Form.Group className="col-md-6 mb-3 relative mt-4">
                    <Form.Label>Termination Date</Form.Label>
                    <Form.Control type="date" name="terminationDate" min={moment().format('YYYY-MM-DD')}
                      value={formatDateInputValue(formData?.terminationDate)}
                      onChange={(e) => setFormData((prevState) => ({ ...prevState, terminationDate: e.target.value, }))}
                    />
                  </Form.Group>

                  <Form.Group className="col-md-12 mb-6 mt-4">
                    <div className="form-check btn-checkbox">
                      <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault"
                        checked={formData?.termination_reach_me ? true : false}
                        onChange={() => {
                          setFormData((prevState) => ({ ...prevState, termination_reach_me: !formData?.termination_reach_me, }));
                        }}
                      />
                      <label className="form-check-label" htmlFor="flexCheckDefault" > I am happy to be reached if you have any questions. </label>
                    </div>
                  </Form.Group>
                </div>
              </Row>
            </Modal.Body>

            <Modal.Footer style={{ alignItems: 'center', justifyContent: 'center', padding: '45px 60px', }} >
              <div className="text-center">
                <button type="button" className="btn btn-primary" style={{ borderRadius: '5px', backgroundColor: '#3E5D58', padding: '8px 18px', }} onClick={() => { handleConsentDialog(); }} > Submit </button>
              </div>
            </Modal.Footer>
          </Modal>
          }

          {<Modal size="lg" show={showSignatureDialog} onHide={() => setShowSignatureDialog(false)} >
            <Modal.Header> <Modal.Title>Termination</Modal.Title> </Modal.Header>

            <Modal.Body>
              <Row>
                <UserSignature field_label="Signature:" handleSignatureDialog={handleSignatureDialog} setShowSignatureDialog={setShowSignatureDialog} onChange={setSignatureImage} />
              </Row>
            </Modal.Body>

            <Modal.Footer style={{ alignItems: 'center', justifyContent: 'center', padding: '45px 60px', }} >
              <div className="text-center">
                {/* <button 
                  type="button" 
                  className="btn btn-primary" 
                  style={{ borderRadius: '5px', backgroundColor: '#3E5D58', padding: "8px 18px" }}onClick={() => handleSignatureDialog()}>Submit</button> */}
              </div>
            </Modal.Footer>
          </Modal>
          }
          {createUserModal && (
            <Modal show={createUserModal} onHide={() => setCreateUserModal(false)} >
              <Modal.Header> <Modal.Title>Creating User</Modal.Title> </Modal.Header>
              <Modal.Body>
                <div className="create-training-modal" style={{ textAlign: 'center' }} >
                  <p>User details are being updated!</p>
                  <p>Please Wait...</p>
                </div>
              </Modal.Body>
              <Modal.Footer style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', }} >
                {loader === true && (<div> <ReactBootstrap.Spinner animation="border" /> </div>)}
              </Modal.Footer>
            </Modal>
          )}

          <Modal show={fileDeleteConfirm.show} onHide={closeFileDeleteConfirm} centered>
            <Modal.Header closeButton>
              <Modal.Title>Delete document</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              Are you sure you want to delete <strong>{fileDeleteConfirm.fileName}</strong>? This action cannot be undone.
            </Modal.Body>
            <Modal.Footer>
              <Button variant="light" onClick={closeFileDeleteConfirm}>
                Cancel
              </Button>
              <Button variant="danger" onClick={confirmUserFileDelete}>
                Delete
              </Button>
            </Modal.Footer>
          </Modal>
        </section>
      </div>
    </>
  );
};

export default EditUser;
